// extracted by mini-css-extract-plugin
export default {"transferWrap":"Holder_transferWrap__sD883"};